import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { FormsModule }   from '@angular/forms';
import { TabsModule } from 'ng2-bootstrap/tabs'; 
// Modal Component
import { ModalModule } from 'ng2-bootstrap/modal';  
// Components Routing
import { AgenciesRoutingModule } from './agencies-routing.module'; 
 
import { AgencyComponent } from './agency.component';
import { ViewagentComponent } from './viewagent.component';
import { AddagentComponent } from './addagent.component'; 
import { AddagentpicComponent } from './addagentpic.component'; 
import { AddagentceoComponent } from './addagentceo.component'; 
import { AssignedComponent } from './assigned.component';
import { ExpiredComponent } from './expired.component'; 
import { ChangeagentComponent } from './changeagent.component'; 
import { ViewagentperformanceComponent } from './viewagentperformance.component'; 
import { RepoagencyComponent } from './repoagency.component'; 
import { ViewrepoagentComponent } from './viewrepoagent.component';
import { AddrepoagentComponent } from './addrepoagent.component'; 
import { Addrepoagent2Component } from './addrepoagent2.component'; 
import { Addrepoagent3Component } from './addrepoagent3.component';  
import { EditagentComponent } from './editagent.component'; 
import { Editagent2Component } from './editagent2.component'; 
import { Editagent3Component } from './editagent3.component'; 
import { AgencyassignmentComponent } from './agencyassignment.component';
import { DiscountrequestedComponent } from './discountrequested.component'; 
import { AgencyService } from '../_Services/agency.service';
import { DebtService } from '../_Services/debt.service'; 

import { AdduserComponent } from './adduser.component';

// Pagination
import { NgxPaginationModule } from 'ngx-pagination';

import { CommonService } from '../_Services/common.service';

@NgModule({
  imports: [
    AgenciesRoutingModule, 
    ModalModule.forRoot(), 
    CommonModule, 
    FormsModule,
    TabsModule,
    ChartsModule,
    DropdownModule,
    NgxPaginationModule
  ],
  declarations: [ 
      AgencyComponent,
      ViewagentComponent,
      AddagentComponent,
      AddagentpicComponent,
      AddagentceoComponent,
      AssignedComponent,
      ExpiredComponent,
      ChangeagentComponent, 
      ViewagentperformanceComponent,
      RepoagencyComponent,
      ViewrepoagentComponent,
      AddrepoagentComponent,
      Addrepoagent2Component,
      Addrepoagent3Component, 
      EditagentComponent,
      Editagent2Component,
      Editagent3Component,
      AgencyassignmentComponent,
      DiscountrequestedComponent, 
      AdduserComponent
  ],
  providers: [
     AgencyService,
     DebtService,
     CommonService
  ]
})
export class AgenciesModule { }



// WEBPACK FOOTER //
// ./src/app/agencies/agencies.module.ts